<template>
  <div class="bto-sb-event-odds">
    <div class="bto-sb-event-odds-right">
      <div v-if="showEventCode" class="bto-sb-event-code">{{item.eventCode}}</div>
      <div class="bto-sb-event-time">
        <span class="bto-sb-event-inntime">{{item.time}}</span>
        <span class="bto-sb-event-inndate">{{item.date}}</span>
      </div>
      <div :class="['bto-sb-event-odds-info-cell',
        {'bto-sb-event-odds-info-cell-m' : (showFavorites ? !showStatistics : showStatistics)},
        {'bto-sb-dp-none' : (!showFavorites && !showStatistics)}]">
        <span class="bto-sb-event-livestream" v-if="item.hasLiveStream"><i :title="t('Mobile.LiveStream')" class="bto-app-live-stream-o"></i></span>
        <favorite-component v-if="showFavorites" :match="item"></favorite-component>
        <statistics-component v-if="showStatistics" :betRadarId="item.betRadarId" :feedProvider="item.feedProvider" :isAwayAtHome="item.awayAtHome" :isLive="item.isLiveMatch" :sportId="item.sportId" :tournamentName="item.tournamentName"/>
      </div>
      <div class="bto-sb-event-odds-cell bto-sb-event-odds-cell-description">
        <match-expanded-odd-component
          v-bind:item="item"
          v-bind:odd="firstCol"
          v-bind:outcome="firstCol.outcomes[0]"
          v-bind:isPrematch="true"
          v-bind:teamIcon="showTeamIcon ? item.homeTeamIcon : ''"
          v-bind:eventDescription="eventDescription"
          v-bind:teamName="item.homeTeam"/>
        <match-expanded-odd-component
          v-if="firstCol.outcomes.length > 2"
          v-bind:item="item"
          v-bind:odd="firstCol"
          v-bind:outcome="firstCol.outcomes[1]"
          v-bind:isPrematch="true"
          v-bind:isDraw="true"/>
        <match-expanded-odd-component
          v-bind:item="item"
          v-bind:odd="firstCol"
          v-bind:outcome="firstCol.outcomes.length > 2 ? firstCol.outcomes[2] : firstCol.outcomes[1]"
          v-bind:isPrematch="true"
          v-bind:teamIcon="showTeamIcon ? item.guestTeamIcon : ''"
          v-bind:eventDescription="eventDescription"
          v-bind:teamName="item.guestTeam"/>
      </div>
      <a class="bto-sb-event-odds-cell bto-sb-event-more-odd"
        :class="{'bto-sb-event-more-odd-active': showDetails, 'bto-sb-event-more-cash' : cashOutVisibility}"
        @click="toggleDetails()">
        +{{showMarketsInMatch === true ? item.numberOfMarkets : item.numberOfOdds}}
         <i class="bto-app-cash" v-if="cashOutVisibility"></i>
      </a>
    </div>
    <embeded-match-details
      v-bind:matchIdProp="item.matchId"
      v-bind:matchTypeProp="`prematch`"
      v-bind:latamLayout="singleMarketView"
      v-if="showDetails === true">
    </embeded-match-details>
  </div>
</template>
<script>
  import MatchItemComp from './match-item-comp';
  import MatchExpandedOddComponent from '../match/match-expanded-odd-component';
  export default {
    name: 'MatchItemLatam',
    extends: MatchItemComp,
    components: {
      MatchExpandedOddComponent,
    }
  };
</script>
